import { render, staticRenderFns } from "./UserActivityWidget.vue?vue&type=template&id=bbedd33a&scoped=true&"
import script from "./UserActivityWidget.vue?vue&type=script&lang=js&"
export * from "./UserActivityWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityWidget.vue?vue&type=style&index=0&id=bbedd33a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbedd33a",
  null
  
)

export default component.exports